"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _file = require("@ys/utils/lib/file");
var _default = exports.default = {
  name: 'YsFilesDownload',
  props: {
    fileList: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async downloadFileList() {
      try {
        this.loading = true;
        for (const file of this.fileList) {
          await (0, _file.downloadFile)(file?.path);
        }
        this.$emit('change');
        this.isDownLoading = false;
      } finally {
        this.loading = false;
      }
    }
  }
};